export default __webpack_public_path__ + "assets/images/Payment_01.468ee9.png";